import React, { useContext } from 'react';
import useBookingSearchForm from './BookingSearchForm.hook';
import BookingSearchFormForm from './BookingSearchFormForm';
import Loader from '../../shared/loaders/Loader';
import Page from '../../shared/layouts/Page';
import CustomButton from '../CustomButton/CustomButton';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';
import custom from '../../custom';

export default function BookingSearchForm() {
  const { state, actions } = useBookingSearchForm();
  const {
    actions: { translate },
  } = useContext(LanguageContext);
  const { state: theme } = useContext(ThemeContext);

  const SHOW_BOOKING_LIST = 'showBookingList' in theme ? theme.showBookingList : true;

  return (
    <Page
      footer={
        !state.loading && !state.isAutoSearch ? (
          <div className={'footer-button-container'}>
            <CustomButton
              htmlType="submit"
              text={translate('continue')}
              form="BookingSearchFormForm"
              disabled={!state.ready}
            />
            {theme?.isKiosk && SHOW_BOOKING_LIST && (
              <>
                <span className={'separator'} />
                <CustomButton
                  text={translate('kiosk.bookingList.title')}
                  onClick={actions.goToBookingSelector}
                  secondary={true}
                />
              </>
            )}
            {state?.extraFields &&
              custom.customComponents({
                chainSlug: state?.chain,
                component: 'BookingSearchExtraFields',
                props: { state, actions },
              })}
            <style jsx>{`
              .footer-button-container {
                display: flex;
                flex-direction: column;
              }
              .separator {
                margin-top: 16px;
              }
            `}</style>
          </div>
        ) : null
      }
      backButton={theme?.isKiosk}
    >
      {state.loading || state.isAutoSearch ? (
        <Loader></Loader>
      ) : (
        <BookingSearchFormForm state={state} actions={actions}></BookingSearchFormForm>
      )}
    </Page>
  );
}
